import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import Popup from "../../common/popup/projectPopup";
import { Autoplay } from "swiper/modules";

const Portfolio = () => {
  const [showModal, setShowModal] = useState(false);
  const [projects, setProjects] = useState([]);
  const [projectData, setProjectData] = useState(null);
  const [projectLikes, setProjectLikes] = useState([]);

  const showPopup = (project) => {
    setShowModal(true);
    const data = projects.filter((p) => p._id == project);
    setProjectData(data);
  };

  const hidePopup = () => {
    setShowModal(false);
  };

  useEffect(() => {
    const fetchProjectData = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_BACKEND_KEY + "projects");
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const responseData = await response.json();
        setProjects(responseData.project);

        // Fetch likes for each project
        const likesObj = {};
        for (const p of responseData.project) {
          try {
            const likeRes = await fetch(
              process.env.REACT_APP_BACKEND_KEY + `likes/${p._id}`
            );
            const contentType = likeRes.headers.get("content-type");

            if (contentType && contentType.includes("application/json")) {
              const likeData = await likeRes.json();
              likesObj[p._id] = likeData.likes;
            } else {
              likesObj[p._id] = 0;
            }
          } catch (likeErr) {
            likesObj[p._id] = 0;
          }
        }

        setProjectLikes(likesObj);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchProjectData();
  }, []);

  const submitLike = async (projectId) => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_KEY + `likes/${projectId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ likes: 1 }),
        }
      );

      if (!response.ok) {
        throw new Error("Error! not able to save the data.");
      }

      // Update likes state optimistically
      setProjectLikes((prevLikes) => ({
        ...prevLikes,
        [projectId]: (prevLikes[projectId] || 0) + 1,
      }));
    } catch (error) {
      console.error("Error submitting like:", error);
    }
  };

  return (
    <>
      <section
        className="portfolio-style-one space-y-top space-y-bottom"
        id="portfolio"
      >
        <div className="container">
          <div className="section-heading pb-5">
            <h2>FEATURED WORK</h2>
          </div>
        </div>
        <div className="container-right">
          <Swiper
            className="swiper portfolio-slider"
            spaceBetween={50}
            breakpoints={{
              1200: { slidesPerView: 3 },
              990: { slidesPerView: 2 },
              640: { slidesPerView: 1 }, // Limit to one tile for mobile screens
            }}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            modules={[Autoplay]}
            loop={true}
          >
            <div className="swiper-wrapper">
              {projects.length > 0 &&
                projects.map((project, index) => (
                  <SwiperSlide key={index}>
                    <div className="swiper-slide">
                      <div className="portfolio-card">
                        <div className="portfolio-img">
                          <a
                            onClick={() => showPopup(project._id)}
                            data-bs-toggle="modal"
                            data-bs-target="#portfolioModal"
                          >
                            <img
                              src={`${process.env.REACT_APP_ASSET_KEY}${project.displayImg}`}
                              alt="portfolio-item"
                            />
                          </a>
                        </div>
                        <div className="portfolio-disc">
                          <ul className="portfolio-meta">
                            <li>{project.client}</li>
                            <li>
                              <span
                                className="like"
                                onClick={() => submitLike(project._id)}
                              >
                                <i className="bi bi-hand-thumbs-up-fill"></i>{" "}
                                Like
                              </span>
                              {projectLikes[project._id] > 0 && (
                                <span className="showLike">
                                  {" "}
                                  : {projectLikes[project._id]} Like
                                  {projectLikes[project._id] === 1 ? "" : "s"}
                                </span>
                              )}
                            </li>
                          </ul>
                          <h4 className="portfolio-title">
                            <a
                              onClick={() => showPopup(project._id)}
                              data-bs-toggle="modal"
                              data-bs-target="#portfolioModal"
                            >
                              {project.title}
                              <i className="bi bi-arrow-up-right"></i>
                            </a>
                          </h4>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
            </div>
          </Swiper>
        </div>
      </section>
      <Popup showBoolean={showModal} onClick={hidePopup} data={projectData} />
    </>
  );
};

export default Portfolio;
